@if (parentForm) {
  <div [formGroup]="parentForm">
    <input
      class="form-control"
      [matAutocomplete]="auto"
      formControlName="location"
      matInput
      #input
      (input)="searchChange(input.value)"
      [placeholder]="'front.create-task-modal.search' | translate"
      type="text"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayLocation.bind(this)"
    >
      @for (option of filteredOptions(); track option) {
        <mat-option [value]="option">{{ displayLocation(option) }}</mat-option>
      }
    </mat-autocomplete>
  </div>
  <div style="height: 20px">
    @if (isLocationInvalid) {
      <div style="color: red">Location is required</div>
    }
  </div>
}
